import { companyPaymentGatewaysConstants } from '_store/_constants';
import service from '../../../services/companyPaymentGateways.service';

const fetchAvailablePaymentMethods = () => {
  return dispatch => {
    dispatch(request());

    service.getAvailablePaymentMethods().then(
      response => {
        dispatch(success(response.data));
      },
      error => {
        dispatch(error);
      },
    );
  };

  function request() {
    return {
      type: companyPaymentGatewaysConstants.COMPANY_PAYMENT_METHODS_FETCH_REQUEST,
    };
  }

  function success(paymentMethods) {
    return {
      type: companyPaymentGatewaysConstants.COMPANY_PAYMENT_METHODS_FETCH_SUCCESS,
      payload: { paymentMethods },
    };
  }

  function failure(error) {
    return {
      type: companyPaymentGatewaysConstants.COMPANY_PAYMENT_METHODS_FETCH_FAILURE,
      payload: { error },
    };
  }
};

export default fetchAvailablePaymentMethods;
